// const baseURL = `http://localhost:5580/`;
// const baseURL = `http://192.168.1.31:5580/`;
// const baseURL=`http://88.99.5.236:9090/`;
// const baseURL=`http://localhost:9090/`;

// const baseURL=`https://dashboard.wheel2fortune.com/`;
// const baseURL=`http://reportkenya.visiontrek.in/`;


const baseURL = `/`;
// const baseURL = `https://reportkenyasafaricom.visiontrek.in/`
export { baseURL ,TrafficDataApi};


const TrafficDataApi =`${baseURL}api/traffic-data`;


 const TrafficApi =`${baseURL}api/hourly-traffic`;
 export {TrafficApi}

 const DigitizeTrafficApi = `${baseURL}api/hourly-traffic/digitize`
 export {DigitizeTrafficApi}

  const subDataHourly =`${baseURL}api/hourly-data-only-sub`;
  export {subDataHourly}

  const DigitizeSubDataHourly =`${baseURL}api/hourly-data-only-sub/digitize`
  export {DigitizeSubDataHourly}

const Hourlyapi = `${baseURL}api/hourly-data`;
export { Hourlyapi };

const DigitizeHourlyApi=`${baseURL}api/hourly-data/digitize`
export {DigitizeHourlyApi}

const dailyapi = `${baseURL}api/daily`;
export { dailyapi };

const DigitizeDailyApi =`${baseURL}api/digitizeAi-daily`
export {DigitizeDailyApi}

const msiAPi = `${baseURL}api/mis`;
export { msiAPi };

const DigitizeMisApi=`${baseURL}api/digitize-mis`
export {DigitizeMisApi}

const specificApi = `${baseURL}api/fetch-mis/specific`;
export {specificApi};

const checkingLogs = `${baseURL}api/fetch-mis`
export {checkingLogs}

const CheckHourlyLogsApi =`${baseURL}api/fetch-hourly-logs`
export {CheckHourlyLogsApi}

const CheckDailyBillingLogsApi =`${baseURL}api/fetch-billing-logs`
export {CheckDailyBillingLogsApi}
const SubscriptionApi = `${baseURL}api/upload/sub`
export {SubscriptionApi}
const SubscriptionBaseInfoApi =`${baseURL}api/upload/sub/base-info`
export {SubscriptionBaseInfoApi}
const UnSubscriptionApi =`${baseURL}api/upload/unsub`
export {UnSubscriptionApi}
const UnsubSingleUSer =`${baseURL}api/upload/unsub/single`
export {UnsubSingleUSer}
const SingleDNDSpecificLogs =`${baseURL}api/fetch-mis/specific-dnd`
export {SingleDNDSpecificLogs}

//  const userlogsapi =`${baseURL}api/userlogs`
//  export {userlogsapi}

//  const FullUserLogsApi =`${baseURL}api/userlogs/full-userlogs`
//  export {FullUserLogsApi}

//  const DigitizeUserLogsApi=`${baseURL}api/userlogs/digitize`
//  export {DigitizeUserLogsApi}

 const trendApi =`${baseURL}api/fetch-hourly-trend`
 export {trendApi}

const unSubApi =`${baseURL}api/unsub`
export {unSubApi}

const DigitizeUnSubApi=`${baseURL}api/unsub/digitize`
export {DigitizeUnSubApi}

const blackListApi=`${baseURL}api/dnd`
export {blackListApi}

const DigitizeBlacklistApi=`${baseURL}api/dnd/Digitize`
export {DigitizeBlacklistApi}

 //visiongames api
 const visiongamesdailyapi = `${baseURL}api/visionGames-daily`;
export { visiongamesdailyapi };

const msiVisionGamesAPi = `${baseURL}api/visionGames-mis`;
export { msiVisionGamesAPi };

const visionGamestrendApi =`${baseURL}api/fetch-hourly-trend/visionGames`
 export {visionGamestrendApi}

 const DigitizeTrendApi =`${baseURL}api/fetch-hourly-trend/digitize`
 export {DigitizeTrendApi}

 const unSubVisionGamesApi =`${baseURL}api/unsub/visionGames`
export {unSubVisionGamesApi}

const blackListVisionGamesApi=`${baseURL}api/dnd/Visiongames`
export {blackListVisionGamesApi}

// const visiongamesuserlogsapi =`${baseURL}api/userlogs/visionGames`
//  export {visiongamesuserlogsapi}


 const VisionGamesHourlyapi = `${baseURL}api/hourly-data/visiongames`;
export { VisionGamesHourlyapi };

const VisionGamesTrafficApi =`${baseURL}api/hourly-traffic/visiongames`;
export {VisionGamesTrafficApi}

const VisionGamesSubDataHourly =`${baseURL}api/hourly-data-only-sub/visiongames`;
export{VisionGamesSubDataHourly}



//previous day total revenue

const prevRevenueApi=`${baseURL}api/lastDay-revenue`
export {prevRevenueApi}

const VisiongamesprevRevApi=`${baseURL}api/visionGames-lastDay-revenue`
export {VisiongamesprevRevApi}

const DigitizePrevRevApi=`${baseURL}api/digitize-lastDay-revenue`
export {DigitizePrevRevApi}

const WonderMindPrevRevApi=`${baseURL}api/wondermind-lastDay-revenue`
export {WonderMindPrevRevApi}

const KickwinPrevRevApi=`${baseURL}api/kickwin-lastDay-revenue`
export {KickwinPrevRevApi}

const RestartServiveApi = (serviceName) => `${baseURL}api/restart/${serviceName}`;
export { RestartServiveApi };



//kickwin-wondermind


const WonderMindDailyApi =`${baseURL}api/wondermind-daily`
export {WonderMindDailyApi}

const KickWinDailyApi =`${baseURL}api/kickwin-daily`
export {KickWinDailyApi}



const WonderMindMisApi=`${baseURL}api/wondermind-mis`
export {WonderMindMisApi}

const KickwinMisApi=`${baseURL}api/kickwin-mis`
export {KickwinMisApi}



const WondermindHourlyApi=`${baseURL}api/hourly-data/wondermind`
export {WondermindHourlyApi}

const KickwinHourlyApi=`${baseURL}api/hourly-data/kickwin`
export {KickwinHourlyApi}

 const WondermindTrafficApi = `${baseURL}api/hourly-traffic/wondermind`
 export {WondermindTrafficApi}

  const KickwinTrafficApi = `${baseURL}api/hourly-traffic/kickwin`
 export {KickwinTrafficApi}


 const WondermindSubDataHourly =`${baseURL}api/hourly-data-only-sub/wondermind`
  export {WondermindSubDataHourly}

  const KickwinSubDataHourly =`${baseURL}api/hourly-data-only-sub/kickwin`
  export {KickwinSubDataHourly}



  const WondermindBlacklistApi=`${baseURL}api/dnd/Wondermind`
export {WondermindBlacklistApi}

const KickwinBlacklistApi=`${baseURL}api/dnd/Kickwin`
export {KickwinBlacklistApi}


const WondermindUnSubApi=`${baseURL}api/unsub/Wondermind`
export {WondermindUnSubApi}

const KickwinUnSubApi=`${baseURL}api/unsub/Kickwin`
export {KickwinUnSubApi}



// const WondermindUserLogsApi=`${baseURL}api/userlogs/Wondermind`
//  export {WondermindUserLogsApi}

//  const KickwinUserLogsApi=`${baseURL}api/userlogs/Kickwin`
//  export {KickwinUserLogsApi}


 const WondermindTrendApi =`${baseURL}api/fetch-hourly-trend/Wondermind`
 export {WondermindTrendApi}

 const KickwinTrendApi =`${baseURL}api/fetch-hourly-trend/Kickwin`
 export {KickwinTrendApi}




 const FullUserLogsApi =`${baseURL}api/userlogs/full-userlogs`;
 export {FullUserLogsApi};


const VisionFullUserLogsApi =`${baseURL}api/userlogs/visionGames/full-userlogs`;
export {VisionFullUserLogsApi};

// const DigitizeFullUserLogsApi =`${baseURL}api/userlogs/digitize/full-userlogs`;
// export {DigitizeFullUserLogsApi};

const DigitizeFullUserLogsApi =`${baseURL}api/userlogs/digitize/full-userlogs`;
export {DigitizeFullUserLogsApi};

const WonderFullUserLogsApi =`${baseURL}api/userlogs/Wondermind/full-userlogs`;
export {WonderFullUserLogsApi};

const KickwinFullUserLogsApi =`${baseURL}api/userlogs/Kickwin/full-userlogs`;
export {KickwinFullUserLogsApi};